import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'underscore';
import { util } from '../util';

// this interceptor transforms a request data to JSON if it is an object
// the default Angular interceptor does this, but we want to filter out all keys that start with '$'
@Injectable()
export class HttpJsonInterceptor implements HttpInterceptor {
  public intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    if (_.isObject(req.body)) {
      req = req.clone({ body: util.toJson(req.body) });
    }

    return next.handle(req);
  }
}